import { useState } from 'react';
import { TermsAndPrivacyTab } from '../components/TermsAndPrivacy/TermsAndPrivacyTab';
import { TermsAndPrivacyContent } from '../components/TermsAndPrivacy/TermsAndPrivacyContent';
import { useSearchParams } from 'react-router-dom';

export function TermsAndPrivacyPage() {
  const [searchParams] = useSearchParams();
  const initialTab =
    searchParams.get('tab') === 'policy' || searchParams.get('tab') === 'terms'
      ? (searchParams.get('tab') as 'terms' | 'policy')
      : 'terms';

  const [activeTab, setActiveTab] = useState<'terms' | 'policy'>(initialTab);

  return (
    <div className="mx-14">
      <TermsAndPrivacyTab activeTab={activeTab} setActiveTab={setActiveTab} />
      <TermsAndPrivacyContent activeTab={activeTab} />
    </div>
  );
}
